function Button({ children, className = '', type = 'button', variant = 'primary', ...props }) {
  const variantClasses =
    variant === 'secondary'
      ? 'border-[#ccbba9] bg-white text-[#111111] shadow-[0_8px_18px_rgba(17,17,17,0.05)] hover:bg-[#f4eee8] hover:border-[#bda893]'
      : 'border-[#6f5644] bg-[#6f5644] text-white shadow-[0_10px_24px_rgba(111,86,68,0.18)] hover:translate-y-[-1px] hover:bg-[#5f4a3b]';

  return (
    <button
      className={`cursor-pointer rounded-xl border px-3.5 py-2.5 font-semibold transition ${variantClasses} ${className}`.trim()}
      type={type}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;
